import Vue from 'vue'
import App from './App.vue'
import router from './routers'
import 'normalize.css/normalize.css'
import ElementUI from 'element-ui'
import './styles/element-variables.scss'
import './styles/index.scss'
import store from './store'

Vue.config.productionTip = false

Vue.use(ElementUI)
new Vue({
  store,
  render: h => h(App),
  router
}).$mount('#app')
